import React from 'react';

import { ControlContentProvider } from './controlContent';
import { AuthProvider } from './auth';
import { FeatureProvider } from './features';

export default function AppProvider({ children }) {
  return (
    <AuthProvider>
      <FeatureProvider>
        <ControlContentProvider>
          {children}
        </ControlContentProvider>
      </FeatureProvider>
    </AuthProvider>
  );
}